import React, { useEffect, useRef, useState } from "react";
import controllerState from "../../service/state/controller.state";
import { observer } from "mobx-react-lite";
import iconOn from "../../images/icons/on_red48.svg";
import iconOff from "../../images/icons/off_dark_grey48.svg";
import iconList from "../../images/icons/menu_dark_grey32.svg";

export const TagControllerFilter = observer(() => {
  const refContainer = useRef(null);
  const [visibleList, setVisibleList] = useState(false);

  useEffect(() => {
    const clickHandler = (e) => {
      // Если кликнули по кнопке открытия, ничего не делаем (она сама переключит стейт)
      if (e.target.closest(".tag_controller_filter_list_btn")) return;

      if (refContainer.current && !refContainer.current.contains(e.target)) {
        setVisibleList(false);
      }
    };

    document.addEventListener("click", clickHandler);
    return () => document.removeEventListener("click", clickHandler);
  }, []); // Пустой массив ок, если внутри проверяем target правильно

  return (
    <div>
      <img
        className="tag_controller_filter_list_btn"
        src={iconList}
        alt="Показать фильтры"
        onClick={() => setVisibleList(true)}
      />
      {visibleList ? (
        <ul ref={refContainer} className="tag_controller_filter_container">
          <li className="tag_controller_filter_row login_form-name ">
            Включить/отключить отображение
          </li>
          {controllerState.history_controller.map((tag) => (
            <li className="tag_controller_filter_row">
              {tag?.name_tag}{" "}
              <img
                className="tag_controller_filter_btn"
                src={tag.tag_active ? iconOn : iconOff}
                alt={tag.tag_active ? "Показать" : "Скрыть"}
                onClick={() => controllerState.viewHiddenTag(tag)}
              />
            </li>
          ))}
        </ul>
      ) : (
        <></>
      )}
    </div>
  );
});
